<ng-container *ngIf="socialChallenge">
  <div class="challenge">
    <kf-sc-social-challenge-menu
      class="challenge-menu"
      [challenge]="socialChallenge"
      *ngIf="socialChallenge.status.state !== socialChallengeState.ended"></kf-sc-social-challenge-menu>
    <div class="challenge-col challenge-info">
      <div class="challenge-image hidden-print" *ngIf="socialChallenge.mediaObject?.url != null">
        <img
          [src]="socialChallenge.mediaObject.url + '?w=1080'"
          [alt]="socialChallenge.mediaObject.description ?? ''" />
      </div>
      <div class="challenge-details">
        <h2 class="title challenge-title">
          {{ socialChallenge.title }}
        </h2>
        <div class="challenge-labels">
          <kf-sc-social-challenge-label
            class="challenge-label"
            [challenge]="socialChallenge"></kf-sc-social-challenge-label>
          <kui-label-flag color="var(--onBackground)" [backgroundColor]="backgroundColor">
            <svg-icon src="/assets/icons/users-group.svg"></svg-icon>
            {{ socialChallenge.group.status.participating }} joined
          </kui-label-flag>
        </div>
        <div class="challenge-description">
          <kui-rich-text [richText]="socialChallenge.description"></kui-rich-text>
        </div>
      </div>
      <div
        class="challenge-call-to-action"
        *ngIf="
          !socialChallenge.groupGoalCompleted &&
          !socialChallenge.individualGoalCompleted &&
          socialChallenge.status.state !== socialChallengeState.ended
        ">
        <button
          class="button button-reverse button-pill button-join"
          (click)="joinChallenge(socialChallenge)"
          *ngIf="!socialChallenge.individual.status.enrolled">
          Join Challenge
        </button>
        <button
          class="button button-w-icon button-reverse button-pill button-opaque-border button-start-days"
          disabled
          *ngIf="
            socialChallenge.individual.status.enrolled && socialChallenge.status.state === socialChallengeState.upcoming
          ">
          <svg-icon src="/assets/icons/clock.svg"></svg-icon>
          Starts in {{ daysToStart }} Day{{ daysToStart === 1 ? '' : 's' }}
        </button>
        <a
          routerLink="./"
          fragment="actions"
          class="button button-reverse button-pill button-take-action"
          *ngIf="
            socialChallenge.individual.status.enrolled &&
            socialChallenge.status.state === socialChallengeState.active &&
            !socialChallenge.individual.status.completedToday
          ">
          Take Action
        </a>
        <a
          routerLink="./"
          fragment="actions"
          class="button button-w-icon button-pill button-opaque-border button-completed-today"
          *ngIf="
            !socialChallenge.groupGoalCompleted &&
            !socialChallenge.individualGoalCompleted &&
            socialChallenge.individual.status.enrolled &&
            socialChallenge.status.state === socialChallengeState.active &&
            socialChallenge.individual.status.completedToday
          ">
          <svg-icon src="/assets/icons/checkmark.svg"></svg-icon>
          Completed Today!
        </a>
      </div>
    </div>
    <div class="challenge-col challenge-progress">
      <!--   using [] for "title" binding as the html title attribute leads to unintentional browser hover tooltip   -->
      <kf-sc-social-challenge-detail-progress
        [title]="'Our Progress'"
        type="group"
        [challengeStatus]="socialChallenge.status"
        [challengeObjective]="socialChallenge.objective"
        [challengeGoalCompleted]="socialChallenge.groupGoalCompleted"
        [challengeId]="socialChallenge.id"
        [challengeInfo]="socialChallenge.group"
        [challengeTitle]="socialChallenge.title"
        [enrolled]="socialChallenge.individual.status.enrolled"
        [inviteMessage]="socialChallenge.inviteMessage">
        <kf-sc-social-challenge-progress
          class="challenge-progress-visual"
          [groupGoal]="socialChallenge.group.goal"
          [groupProgress]="socialChallenge.group.status.progress?.count || 0"
          [groupExclusive]="true"></kf-sc-social-challenge-progress>
      </kf-sc-social-challenge-detail-progress>
      <!--   using [] for "title" binding as the html title attribute leads to unintentional browser hover tooltip   -->
      <kf-sc-social-challenge-detail-progress
        [title]="'My Progress'"
        type="individual"
        [challengeStatus]="socialChallenge.status"
        [challengeObjective]="socialChallenge.objective"
        [challengeId]="socialChallenge.id"
        [challengeGoalCompleted]="socialChallenge.individualGoalCompleted"
        [challengeTitle]="socialChallenge.title"
        [challengeInfo]="socialChallenge.individual">
        <kf-sc-social-challenge-progress
          class="challenge-progress-visual"
          [individualGoal]="socialChallenge.individual.goal"
          [individualProgress]="socialChallenge.individual.status.progress?.count || 0"
          [individualExclusive]="true"></kf-sc-social-challenge-progress>
      </kf-sc-social-challenge-detail-progress>
    </div>
  </div>
  <div
    id="actions"
    class="challenge-actions"
    *ngIf="
      ![socialChallengeState.upcoming, socialChallengeState.ended].includes(socialChallenge.status.state) &&
      socialChallenge.individual.status.enrolled
    ">
    <div class="challenge-actions-container">
      <div class="actions-description">
        <h3 class="actions-title">
          <svg-icon class="challenge-icon" src="/assets/icons/checkmark-empty-circle.svg"></svg-icon>
          Challenge Actions
        </h3>
        <p class="actions-description">
          Complete any {{ socialChallenge.domain?.name }} action within Purposeful each day to earn
          {{ socialChallenge.objective }}.
        </p>
      </div>
      <ng-container *ngIf="cardBloc.challengeActionCollection$ | async as collectionsStatus">
        <kp-take-action
          [cardCollections]="collectionsStatus.data"
          [cardScreen]="cardScreen"
          [isChallenge]="true"></kp-take-action>
      </ng-container>
    </div>
    <div *ngIf="cardBloc.domainAvailableCollection$ | async as collections">
      <kp-card-category
        class="card-category"
        *ngFor="let cardCollection of collections.data; let i = index"
        [customCardCategory]="customCardCategory"
        [cardCollection]="cardCollection"
        [screen]="cardScreen"
        [isLoading]="collections.status === loadingStatus"
        [categoryIndex]="i"
        [requestType]="cardRequestType"></kp-card-category>
    </div>
    <a
      class="button button-pill button-secondary button-search"
      routerLink="/discover"
      [queryParams]="{ searchTerm: socialChallenge.domain?.term, searchName: socialChallenge.domain?.name }">
      <svg-icon class="search-icon" src="assets/icons/icons-magnifying-glass.svg"></svg-icon>
      Find More
    </a>
  </div>
</ng-container>

<router-outlet></router-outlet>
